import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-form-concepts',
  template: `
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label for="name" class="form-label">Nombre</label>
          <input type="text" class="form-control" id="name" placeholder="Nombre del concepto">
        </div>
      </div>
    </div>
  `,
  styleUrls: []
})
export class FormConceptsComponent implements OnInit {

  conceptForm: FormGroup = new FormGroup({});

  constructor(
    private fb: FormBuilder,
  ) { }

  ngOnInit(): void {
  }

  // initForm() {
    // this.conceptForm = this.fb.group({});
  // }

}
